import { configureStore } from "@reduxjs/toolkit";
import ProfileReducer from "./profile";

import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import autoMergeLevel2 from "redux-persist/lib/stateReconciler/autoMergeLevel2";

const persistConfig = {
  key: "root",
  storage,
  stateReconciler: autoMergeLevel2,
};

const persistedReducer = persistReducer(persistConfig, ProfileReducer);

let store = configureStore({
  reducer: {
    profile: persistedReducer,
  },
});
let persistor = persistStore(store);
export { store, persistor };
